import {
  BasketballEventStatusId,
  BasketballIncidentId,
} from '@collector/sportsapi-client-legacy'

import { EventStatusIncidentsOnFieldConfig } from '../../configuration'

export const eventStatusIncidentsOnFieldConfig: EventStatusIncidentsOnFieldConfig =
  {
    eventStatusToIncidentIdMap: new Map<
      BasketballEventStatusId,
      BasketballIncidentId[]
    >([
      [
        BasketballEventStatusId.NotStarted,
        [
          BasketballIncidentId.MatchAboutToStart,
          BasketballIncidentId.JumpBall,
          BasketballIncidentId.FirstQuarterStarted,
        ],
      ],
      [
        BasketballEventStatusId.StartDelayed,
        [
          BasketballIncidentId.MatchAboutToStart,
          BasketballIncidentId.JumpBall,
          BasketballIncidentId.FirstQuarterStarted,
        ],
      ],
      [
        BasketballEventStatusId.BreakAfterFirstQuarter,
        [BasketballIncidentId.SecondQuarterStarted],
      ],
      [
        BasketballEventStatusId.BreakAfterSecondQuarter,
        [BasketballIncidentId.ThirdQuarterStarted],
      ],
      [
        BasketballEventStatusId.BreakAfterThirdQuarter,
        [BasketballIncidentId.FourthQuarterStarted],
      ],

      [
        BasketballEventStatusId.BreakAfterFirstHalf,
        [BasketballIncidentId.SecondHalfStarted],
      ],

      [
        BasketballEventStatusId.WaitingForOvertime,
        [BasketballIncidentId.FirstOvertimeStarted],
      ],
      [
        BasketballEventStatusId.BreakAfterFirstOvertime,
        [BasketballIncidentId.SecondOvertimeStarted],
      ],
      [
        BasketballEventStatusId.BreakAfterSecondOvertime,
        [BasketballIncidentId.ThirdOvertimeStarted],
      ],
      [
        BasketballEventStatusId.BreakAfterThirdOvertime,
        [BasketballIncidentId.FourthOvertimeStarted],
      ],
      [
        BasketballEventStatusId.BreakAfterFourthOvertime,
        [BasketballIncidentId.FifthOvertimeStarted],
      ],
    ]),
    secondHalfIncidentId: BasketballIncidentId.SecondQuarterStarted,
  }
